package com.devi3east.bashbuddy.features.events.detail.domain

import com.devi3east.bashbuddy.features.events.common.data.models.Ticket

data class PendingAddToCart(
    val ticket: Ticket,
    val quantity: Int
)